import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { CssBaseline } from '@mui/material';
import Header from './components/Header';
import Home from './pages/Home';
import IdeaDetail from './pages/IdeaDetail';
import IdeaSubmission from './pages/IdeaSubmission';
import DynamicAbout from './components/DynamicAbout';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Footer from './components/Footer';
import { AuthProvider } from './contexts/AuthContext';
import AdminPage from './pages/AdminPage';
import { ContentProvider } from './contexts/ContentContext';
import { TenantProvider } from './contexts/TenantContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { DynamicThemeProvider } from './components/DynamicThemeProvider';
import { useDocumentTitle } from './hooks/useDocumentTitle';



function App() {
  // Get tenant ID from environment variable, fallback to 'severance'
  const tenantId = process.env.REACT_APP_TENANT_ID || 'severance';
  
  return (
    <TenantProvider>
      <DynamicThemeProvider>
        <LanguageProvider>
          <ContentProvider tenantId={tenantId}>
            <AuthProvider>
              <AppContent />
            </AuthProvider>
          </ContentProvider>
        </LanguageProvider>
      </DynamicThemeProvider>
    </TenantProvider>
  );
}

function AppContent() {
  // Use the document title hook
  useDocumentTitle();
  
  return (
    <>
      <CssBaseline />
      <Router>
        <Header />
        <main style={{ minHeight: 'calc(100vh - 170px)' }}>
          <Routes>
            {/* Redirect root to About page */}
            <Route path="/" element={<Navigate to="/about" replace />} />
            <Route path="/home" element={<Home />} />
            <Route path="/idea/:id" element={<IdeaDetail />} />
            <Route path="/submit" element={<IdeaSubmission />} />
            <Route path="/about" element={<DynamicAbout />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
        </main>
        <Footer />
      </Router>
    </>
  );
}

export default App;
